import React from "react";
import Tooltip from "@toolbox/building-blocks/Tooltip";

import {ILocalizedText} from "@translate/models";

import {parseNumber} from "@translate/T";
import InlineRadio from "./InlineRadio";

interface IInlineRadiosProps<TValue> {
    // contains the displayName & key has to be the TValue
    values: JSX.Element[];
    idSuffix: string;
    selected: TValue;

    breakEachElement?: boolean;
    disabled?: boolean | boolean[];
    titles?: ILocalizedText[];
    tooltips?: React.ReactNode[];

    onSelected(value: TValue): void;
}

class InlineRadios<TValue> extends React.PureComponent<
    IInlineRadiosProps<TValue>
> {
    public render() {
        return this.props.values.map((value, i) => this.renderRadio(value, i));
    }

    private renderRadio(value: JSX.Element, i: number) {
        const {
            disabled,
            idSuffix,
            onSelected,
            breakEachElement,
            selected,
            titles,
            tooltips,
        } = this.props;
        const id = "radios-" + value.key + "-" + idSuffix;
        const radioValue = (typeof selected === "number"
            ? parseNumber(value.key as string)
            : value.key) as unknown as TValue;
        const tooltip = tooltips?.[i];
        const radio = (
            <InlineRadio<TValue>
                idSuffix={id}
                disabled={Array.isArray(disabled) ? disabled[i] : disabled}
                isSelected={selected === radioValue}
                title={titles?.[i]}
                value={radioValue}
                onSelected={onSelected}
            >
                {value}
            </InlineRadio>
        );

        return (
            <React.Fragment key={id}>
                {tooltip ? <Tooltip content={tooltip}>{radio}</Tooltip> : radio}
                {breakEachElement && <br />}
            </React.Fragment>
        );
    }
}

export default InlineRadios;
